export enum PaymentProvider {
  PayPro = 'paypro',
  Polar = 'polar',
}

export enum PaymentEventType {
  SubscriptionPurchased = 'subscription.purchased',
  SubscriptionRenewed = 'subscription.renewed',
  SubscriptionPaymentFailed = 'subscription.payment_failed',
  SubscriptionStatusChanged = 'subscription.status_changed',
  SubscriptionCancelled = 'subscription.cancelled',
  SubscriptionUpdated = 'subscription.updated',
  TopupPurchased = 'topup.purchased',
  RefundReverted = 'refund.reverted',
  Unknown = 'unknown',
}

export enum CancellationReason {
  Refund = 'refund',
  Chargeback = 'chargeback',
  Terminated = 'terminated',
  Finished = 'finished',
}

export enum CheckoutMetadataKey {
  UserId = 'userId',
  PlanId = 'planId',
  ManualUpgrade = 'manualUpgrade',
}

export enum ProrationBehavior {
  Invoice = 'invoice',
  Prorate = 'prorate',
  NextPeriod = 'next_period',
}

export enum PolarWebhookEventType {
  OrderPaid = 'order.paid',
  SubscriptionCreated = 'subscription.created',
  SubscriptionActive = 'subscription.active',
  SubscriptionUpdated = 'subscription.updated',
  SubscriptionCanceled = 'subscription.canceled',
  SubscriptionUncanceled = 'subscription.uncanceled',
  SubscriptionPastDue = 'subscription.past_due',
  SubscriptionRevoked = 'subscription.revoked',
  RefundCreated = 'refund.created',
  RefundUpdated = 'refund.updated',
}

export enum PolarRefundStatus {
  Pending = 'pending',
  Succeeded = 'succeeded',
  Failed = 'failed',
  Canceled = 'canceled',
}

export enum PolarOrderBillingReason {
  Purchase = 'purchase',
  SubscriptionCreate = 'subscription_create',
  SubscriptionCycle = 'subscription_cycle',
  SubscriptionUpdate = 'subscription_update',
}

export enum PolarSubscriptionStatus {
  Incomplete = 'incomplete',
  IncompleteExpired = 'incomplete_expired',
  Trialing = 'trialing',
  Active = 'active',
  PastDue = 'past_due',
  Canceled = 'canceled',
  Unpaid = 'unpaid',
}

export enum PolarRefundReason {
  Fraudulent = 'fraudulent',
  Chargeback = 'chargeback',
}

export enum PolarCheckoutStatus {
  Open = 'open',
  Expired = 'expired',
  Confirmed = 'confirmed',
  Succeeded = 'succeeded',
  Failed = 'failed',
}

export enum PolarServer {
  Sandbox = 'sandbox',
  Production = 'production',
}

/**
 * Status value appended to the frontend redirect after a checkout-return.
 * Kept narrow so the SPA can branch on it safely.
 */
export enum CheckoutReturnStatus {
  Success = 'success',
  Pending = 'pending',
  Error = 'error',
  Invalid = 'invalid',
}
